module.exports = __webpack_public_path__ + "static/media/nexi.5b4d5deb.jpg";